import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import styles from './TeamMemberItem.m.sass';
import Avatar from '../../../../../components/Avatar';
import Icon from '../../../../../components/Icon';
import IconButton from '../../../../../components/IconButton';
import Button from '../../../../../components/Button';
import { Dropdown, DropdownItem, DropdownItemIcon } from '../../../../../components/Dropdown';
var TeamMemberItem = function TeamMemberItem(_ref) {
  var state = _ref.state,
    teamMember = _ref.teamMember;
  var currentTeamMember = state.sessionStore.teamMembers.find(function (x) {
    return x.teamId === state.team.id;
  });
  var viewUserDetails = currentTeamMember || state.sessionStore.member.hasPermission('ADMIN_USER_READ');
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.avatarContainer
  }, /*#__PURE__*/React.createElement(Avatar, {
    url: teamMember.member.avatar,
    fallback: teamMember.member.avatarFallback,
    size: 36
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.title
  }, teamMember.member.displayName), viewUserDetails && /*#__PURE__*/React.createElement("p", {
    className: styles.subtitle
  }, teamMember.member.email)), /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, /*#__PURE__*/React.createElement(ChangeRoleButton, {
    state: state,
    teamMember: teamMember
  }), "\xA0 \xA0", /*#__PURE__*/React.createElement(ActionsDropdown, {
    state: state,
    teamMember: teamMember,
    s: true
  })));
};
export default observer(TeamMemberItem);
var ChangeRoleButton = observer(function ChangeRoleButton(_ref2) {
  var state = _ref2.state,
    teamMember = _ref2.teamMember;
  var currentTeamMember = state.sessionStore.teamMembers.find(function (x) {
    return x.teamId === state.team.id;
  });
  var isAdmin = state.sessionStore.member.hasPermission('ADMIN_MANAGE_TEAM_MEMBER');
  var disabled = state.busy || !currentTeamMember || !currentTeamMember.hasPermission('MANAGE_TEAM_MEMBER');
  return /*#__PURE__*/React.createElement(Dropdown, {
    position: "right",
    disabled: disabled,
    className: styles.dropdownTeamRole,
    button: function button(buttonProps) {
      return /*#__PURE__*/React.createElement(Button, _extends({
        outline: true,
        iconRight: /*#__PURE__*/React.createElement(Icon, {
          material: true,
          name: "arrow drop down"
        }),
        size: "small",
        disabled: !isAdmin && (disabled || !state.allowEdit)
      }, buttonProps), teamMember.teamRole && teamMember.teamRole.name);
    }
  }, state.teamRoles.map(function (role) {
    return /*#__PURE__*/React.createElement(DropdownItem, {
      key: role.id,
      active: role.id === teamMember.teamRoleId,
      onClick: function onClick() {
        return state.changeTeamMemberRole(teamMember, role.id);
      },
      className: styles.dropdownItemLinkTeamRole
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.roleTitle
    }, role.name), /*#__PURE__*/React.createElement("p", null, role.description));
  }));
});
var ActionsDropdown = observer(function ActionsDropdown(_ref3) {
  var state = _ref3.state,
    teamMember = _ref3.teamMember;
  var currentTeamMember = state.sessionStore.teamMembers.find(function (x) {
    return x.teamId === state.team.id;
  });
  var isAdmin = state.sessionStore.member.hasPermission('ADMIN_MANAGE_TEAM_MEMBER');
  var disabled = state.busy || !currentTeamMember || !currentTeamMember.hasPermission('MANAGE_TEAM_MEMBER');
  return /*#__PURE__*/React.createElement(Dropdown, {
    disabled: disabled,
    position: "right",
    button: function button(buttonProps) {
      return /*#__PURE__*/React.createElement(IconButton, buttonProps, /*#__PURE__*/React.createElement(Icon, {
        material: true,
        name: "more vert"
      }));
    }
  }, /*#__PURE__*/React.createElement(DropdownItem, {
    disabled: !isAdmin && (!state.allowEdit || disabled),
    onClick: function onClick(e) {
      return (isAdmin || !disabled) && state.removeTeamMember(teamMember);
    }
  }, /*#__PURE__*/React.createElement(DropdownItemIcon, null, /*#__PURE__*/React.createElement(Icon, {
    material: true,
    name: "delete"
  })), "Remove Member"));
});
//# sourceMappingURL=index.js.map
